import { render } from "./ConcursPublic.vue?vue&type=template&id=1ce20bae&scoped=true"
import script from "./ConcursPublic.vue?vue&type=script&lang=js"
export * from "./ConcursPublic.vue?vue&type=script&lang=js"

import "./ConcursPublic.vue?vue&type=style&index=0&id=1ce20bae&scoped=true&lang=css"
import "./ConcursPublic.vue?vue&type=style&index=1&id=1ce20bae&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce20bae"]])

export default __exports__